import { Epic, StateObservable } from 'redux-observable';
import { IshState } from '../services/IshState';
import { initAnalyticsEvent } from 'src/js/services/CommonAnalyticsService';
import { filter, mergeMap, Observable } from 'rxjs';


export const CommonAnalyticsEpic: Epic<any, IshState> = (action$: Observable<any>, store: StateObservable<IshState>): any => {
  return action$.pipe(
    filter(action => action.meta && action.meta.analytics),
    mergeMap(action => {
      initAnalyticsEvent(action.meta.analytics, store.value);
      return [];
    })
  );
};
